/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.AutocompleteChirpService
 */

export const getRpc = {
  serviceName: 'com.hubspot.learning.center.search.rpc.AutocompleteChirpService',
  rpcName: 'get',
  auth: 'app',
  fingerprint: 'VsoWWWDiYtlSPJhoGbCCNWluNaONdQUP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};